
import { Link } from 'react-router-dom';
import logo from '../../assets/neurasites-logo-sized.svg';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Website Development', href: '/services/website-development' },
    { name: 'E-commerce Solutions', href: '/services/ecommerce' },
    { name: 'SEO Optimization', href: '/services' },
    { name: 'Custom Development', href: '/services' }
  ];

  const company = [
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'Testimonials', href: '/testimonials' },
    { name: 'Blog', href: '/blog' }
  ];

  const support = [
    { name: 'Contact Us', href: '/contact' },
    { name: 'Client Portal', href: '/dashboard' },
    { name: 'FAQ', href: '/contact#faq' }
  ];

  return (
    <footer className="bg-gray-900 dark:bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center mb-4">
              <img src={logo} alt="NeuraSites AI" width={200} height={42} />
            </Link>
            <p className="text-gray-400 mb-6">
              AI-powered web development solutions for modern businesses. Fast, affordable, and professional.
            </p>
            <div className="text-gray-400 text-sm">
              <p>hello@neurasites.ai</p>
              <p>(208) 809-3100</p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              {company.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              {support.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <p className="text-gray-400 text-sm mb-2">Call us:</p>
              <a
                href="tel:208-809-3100"
                className="text-blue-400 hover:text-blue-600 font-semibold"
              >
                (208) 809-3100
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 dark:border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} NeuraSites AI. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="/terms-of-service" className="text-gray-400 hover:text-white text-sm transition-colors">
              Terms of Service
            </a>
            <a 
              href="https://websmithguy.com" 
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Powered by WebSmith Guy 
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
